import { useScrollHintModel } from '@/components/home/components/scroll-hint/scroll-hint.model'
import { ScrollHintView } from '@/components/home/components/scroll-hint/scroll-hint.view'

export function ScrollHintViewModel() {
  const model = useScrollHintModel()
  return <ScrollHintView {...model} />
}
